import React from "react";
import { CategorySearchResultsTemplate } from "themes/application/categories/components";

function CategorySearchResults(props) {
    return <CategorySearchResultsTemplate {...props} />;
}

export default CategorySearchResults;
